import api from '../api'

export default {

  customers: async (page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/customers?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  createGetData: async ()=> {
    return api.get('api/customers/create')
  },

  create: async customer => {
    return api.post('api/customers', customer)
  },

  get: async id => {
    return api.get('api/customers/' + id)
  },

  update: async (id,customer) => {
    return api.put('api/customers/' + id, customer)
  },

  delete: async id => {
    return api.delete('api/customers/' + id)
  },

  upload: async customers => {
    return api.post(`api/customers/upload`,customers)
  },

  balances: async () => {
    return api.get('api/customers/balances')
  },
}
